export default __webpack_public_path__ + "170ebb8b5b5884f5a407a6b3a53191cf.png";